import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { createContactUs } from "../features/PublicAPIsService";
import "./css/ContactUsForm.css";

export default function ContactUsForm() {
  const dispatch = useDispatch();
  const { contactUsLoading } = useSelector(
    (state) => state.PublicAPIsService
  );

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phoneNumber: "",
    message: "",
  });

  const [agree, setAgree] = useState(false);
  const [responseMessage, setResponseMessage] = useState(null);
  const [messageType, setMessageType] = useState("");

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };
  useEffect(() => {
    if (responseMessage) {
      const timer = setTimeout(() => {
        setResponseMessage(null);
        setMessageType("");
      }, 5000);
      return () => clearTimeout(timer);
    }
  }, [responseMessage]);

  const showMessage = (message, type) => {
    setResponseMessage(message);
    setMessageType(type);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setResponseMessage(null);
    setMessageType("");
    if (
      !formData.name.trim() ||
      !formData.email.trim() ||
      !formData.phoneNumber.trim() ||
      !formData.message.trim() ||
      !agree
    ) {
      showMessage("All fields are required", "error");
      return;
    }
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(formData.email)) {
      showMessage("Please enter a valid email address", "error");
      return;
    }
    const phoneRegex = /^[0-9+\-\s]+$/;
    if (!phoneRegex.test(formData.phoneNumber) || formData.phoneNumber.length < 10) {
      showMessage("Please enter a valid phone number", "error");
      return;
    }

    try {
      const res = await dispatch(
        createContactUs({
          ...formData,
          privacyAndPolicy: agree,
        })
      );

      if (res.payload?.success) {
        showMessage(res.payload.message || "Message sent successfully!", "success");
        setFormData({
          name: "",
          email: "",
          phoneNumber: "",
          message: "",
        });
        setAgree(false);
      } else {
        showMessage(res.payload?.message || "Something went wrong. Please try again.", "error");
      }
    } catch (error) {
      showMessage("Network error. Please check your connection.", "error");
    }
  };

  return (
    <div className="customcontainer">
      <div className="contact-us-form">
        <div className="contact-us-form__container">
          <div className="contact-us-form__wrapper">



            <div className="contact-us-form__right">
              <form
                className="contact-us-form__form contact-us-form__page-form"
                onSubmit={handleSubmit} data-aos="fade-up"
              >
                <div className="contact-us-form__field">
                  <input
                    type="text"
                    name="name"
                    placeholder="Name"
                    value={formData.name}
                    onChange={handleChange}
                    required
                  />
                </div>

                <div className="contact-us-form__field">
                  <input
                    type="email"
                    name="email"
                    placeholder="Email"
                    value={formData.email}
                    onChange={handleChange}
                    required
                  />
                </div>

                <div className="contact-us-form__field">
                  <input
                    type="tel"
                    name="phoneNumber"
                    placeholder="Phone"
                    value={formData.phoneNumber}
                    onChange={handleChange}
                    required
                  />
                </div>

                <div className="contact-us-form__field">
                  <textarea
                    name="message"
                    placeholder="Message"
                    value={formData.message}
                    onChange={handleChange}
                    required
                  />
                </div>

                <div className="contact-us-form__checkbox">
                  <label className="form__checkbox-label">
                    <input
                      type="checkbox"
                      checked={agree}
                      onChange={(e) => setAgree(e.target.checked)}
                      required
                    />
                    <span>
                      By submitting this form, I agree to the collection and use
                      of my personal data as per Privacy Policy.
                    </span>
                  </label>
                </div>
                {responseMessage && (
                  <div className={`contact-us-form__response ${messageType}`}>
                    <div className="message-content">
                      <span className="message-icon">
                        {messageType === "success" ? "✓" : "✕"}
                      </span>
                      <span className="message-text">{responseMessage}</span>
                    </div>
                    <button
                      className="message-close"
                      onClick={() => {
                        setResponseMessage(null);
                        setMessageType("");
                      }}
                      aria-label="Close message"
                    >
                      ×
                    </button>
                  </div>
                )}
                <button
                  className={`contact-us-form__submit-btn ${contactUsLoading ? 'loading' : ''}`}
                  type="submit"
                  disabled={contactUsLoading}
                >
                  <span className="btn-text">Send Message</span>
                  {contactUsLoading && (
                    <div className="btn-loader-container">
                      <span className="btn-loader"></span>
                    </div>
                  )}
                </button>
              </form>
            </div>

          </div>
        </div>
      </div>
    </div>
  );
}